import React from 'react';
const stats = [{
  value: '+1.240',
  label: 'detailers activos'
}, {
  value: '6+4',
  label: 'Tomos + Bonos'
}, {
  value: '4.9/5',
  label: 'calificación ⭐'
}, {
  value: '🇦🇷',
  label: 'Todo el país'
}];
const testimonials = [{
  initials: 'LG',
  quote: '"En mi primer fin de semana hice dos pulidos y cobré más que en toda una semana de trabajo. El Tomo 2 de pulido es una locura. Nunca pensé que era tan accesible."',
  author: '— Lucas G., Buenos Aires | Ex Empleado de Comercio'
}, {
  initials: 'MR',
  quote: '"Llevaba años lavando autos sin saber que los estaba rayando. Con el protocolo de los 3 baldes del Tomo 1 cambié todo. Ahora cobro el doble y los clientes me recomiendan solos."',
  author: '— Martín R., Córdoba | Detailer Independiente'
}, {
  initials: 'FA',
  quote: '"El Tomo 5 de negocios me enseñó a cobrar lo que vale mi trabajo. Cerré mi primer sellado cerámico en $280.000 un sábado a la tarde. Sin el MegaPack jamás hubiera sabido cómo presentarlo."',
  author: '— Federico A., Rosario | Dueño de Taller de Estética Automotriz'
}];
export function SocialProof() {
  return <section className="w-full px-4 py-8 text-gray-900 text-base leading-6" style={{
    backgroundColor: '#0e0e0e',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-282">
      <div className="mx-auto max-w-4xl" data-id="element-283">
        {/* Stats Grid */}
        <div className="mb-8 grid grid-cols-2 md:grid-cols-4 gap-3 text-center" data-id="element-284">
          {stats.map(stat => <div key={stat.label} data-id="element-285">
              <div className="text-2xl sm:text-4xl leading-[32px] sm:leading-[40px] font-black text-yellow-400" data-id="element-286">
                {stat.value}
              </div>
              <div className="mt-1 text-[10px] sm:text-xs font-semibold text-gray-400" data-id="element-287">
                {stat.label}
              </div>
            </div>)}
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-288">
          {testimonials.map(t => <div key={t.initials} className="flex items-start gap-2 bg-white/5 border border-yellow-400/20 rounded-lg p-3 shadow-sm" data-id="element-289">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center bg-yellow-400/10 text-xs font-black text-yellow-400 rounded-full" data-id="element-290">
                {t.initials}
              </div>
              <div data-id="element-291">
                <div className="mb-1 text-[10px] text-yellow-400" data-id="element-292">
                  ⭐⭐⭐⭐⭐
                </div>
                <p className="text-xs font-medium text-gray-200 m-0" data-id="element-293">
                  {t.quote}
                </p>
                <p className="text-[10px] text-gray-500 mt-1 mb-0" data-id="element-294">
                  {t.author}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}